<template>
    <div id="app" class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="swiper-container">
        <p class="swiper-control">
        </p>
        <div class="swiper-wrapper timeline">
          <div class="swiper-slide" v-for="item in listhitos" :key="item.creacion">
            <div class="timestamp">
              <span>{{item.creacion}}</span>
            </div>
            <div class="status">
              <span>{{item.estado}}</span>
            </div>
            <div class="depestado">
              <span>{{item.departamento}}</span>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Swiper from 'swiper'
    export default {
        name: 'Timeline',
        components: {
          Swiper
        },
        props:['hitos'],
        data:() => {
            return {
              listhitos: []
            }
        },
        mounted() {
            var swiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            slidesPerView: 4,
            paginationClickable: true,
            grabCursor: true,
            paginationClickable: true,
            nextButton: '.next-slide',
            prevButton: '.prev-slide',
            });
            this.listhitos = this.hitos 
        }
    }
</script>

<style>

.timeline {
  margin: 2px 0;
  list-style-type: none;
  display: flex;
  padding: 0;
  text-align: left;
}
.timeline li {
  transition: all 200ms ease-in;
}
.timestamp {
  width: 200px;
  margin-bottom: 20px;
  margin-left: 1px;
  padding: 10px 5px 5px 10px;
  text-align: center !important;
  display: inline-block;
  flex-direction: column;
  align-items: unset;
  font-weight: 100;
  left: 0;
  
}
.timestamp span {
  margin-right: 10px;
  display: flex;
  /* border: 2px solid #ab2345; */
}
.status {
  padding: 0px 10px;
  display: block;
  justify-content: center;
  border-top: 4px solid #3e70ff;
  position: relative;
  padding-top: 10px;
  transition: all 200ms ease-in ;
  /* border: 3px solid orangered; */
} 
.status span {
  font-weight: 600;
  padding-top: 25px;
}
.status span:before {
  content: '';
  width: 25px;
  height: 25px;
  background-color: #e8eeff;
  border-radius: 25px;
  border: 4px solid #3e70ff;
  position: absolute;
  top: -15px;
  left: 42%;
  transition: all 200ms ease-in;
}
.swiper-control {
  text-align: right;
}

.swiper-container {
  width: 100%;
  height: 200px;
  margin: 20px 0;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.swiper-slide {
  width: 220px;
  text-align: center;
  font-size: 15px;
  /* border: 1px solid blue; */
}
.swiper-slide:nth-child(2n) {
  width: 25%;
}
.swiper-slide:nth-child(3n) {
  width: 20%;
}
.depestado{
  font-size: 11px; 
  font-weight: 100;
  padding-top: 10px;
}
</style>

<style>
@import url('/css/swiper.min.css');
</style>